var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTweetWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8802 2.9841C11.8876 3.09483 11.8876 3.20556 11.8876 3.31731C11.8876 6.72239 9.36003 10.6495 4.7382 10.6495V10.6474C3.3729 10.6495 2.03596 10.2484 0.886597 9.49217C1.08512 9.51667 1.28464 9.52891 1.48466 9.52942C2.61611 9.53044 3.71522 9.1411 4.60535 8.42416C3.53013 8.40324 2.58725 7.68426 2.25787 6.63462C2.63452 6.70912 3.02262 6.69381 3.39231 6.59023C2.22006 6.34734 1.37669 5.29106 1.37669 4.06436C1.37669 4.05313 1.37669 4.04241 1.37669 4.0317C1.72598 4.23122 2.11706 4.34195 2.5171 4.35419C1.41301 3.59745 1.07268 2.09112 1.73941 0.913396C3.01516 2.52332 4.89742 3.50203 6.91801 3.60562C6.7155 2.71059 6.99215 1.7727 7.64494 1.14353C8.65698 0.167881 10.2487 0.217888 11.2 1.25528C11.7627 1.14149 12.3021 0.929724 12.7957 0.629682C12.6081 1.2262 12.2155 1.7329 11.6911 2.05489C12.1892 1.99467 12.6758 1.85792 13.134 1.64922C12.7967 2.16766 12.3718 2.61925 11.8802 2.9841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweetWhite);
export default __webpack_public_path__ + "static/media/tweetWhite.e6d144d8.svg";
export { ForwardRef as ReactComponent };